import { Button, Icon, Modal, Spin } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import BaseLayout from "../../../components/BaseLayout/BaseLayout";
import MilestonesList from "../../../components/Milestones/MilestonesList";
import ModalPlus from "../../../components/ModalPlus/ModalPlus";
import { Baby, MilestonesBaby, User } from "../../../interfaces";
import { AppState, sagaMiddleware } from "../../../store";
import { setDraftBabyPage } from "../../../store/sagas/bpHelper";
import { MilestoneState } from "../../../store/ducks/milestones";
import { fetchMilestones } from "../../../store/sagas/milestone";
import "./MilestonesPage.scss";
import babyCart from "../../../components/Milestones/icons/baby-buggy.png";
import babyFace from "../../../components/Milestones/icons/baby-face.png";
import babyFoot from "../../../components/Milestones/icons/foot-icon.png";
import babyShirt from "../../../components/Milestones/icons/baby-shirt.png";
import babySock from "../../../components/Milestones/icons/stocking.png";
import babyIncomplete from "../../../components/Milestones/icons/incomplete.png";

interface Props {
  babySelected?: Baby;
  milestones: MilestoneState;
  user: User;
  babies: Baby[];
}

const MilestonesPage: React.FC<Props> = ({
  babySelected,
  milestones,
  user,
  babies,
}) => {
  const history = useHistory();
  const [babyPageLimitPlusOpen, setBabyPageLimitPlusOpen] = useState(false);

  const [activefilter, setActiveFilter] = useState<
    | "baby_milestones"
    | "one_year_milestones"
    | "holiday_milestones"
    | "all_milestones"
    | "first_event_milestones"
    | "pregnancy_milestones"
    | "incomplete_milestones"
  >("pregnancy_milestones");


  const [activeMilestoneTitle, setActiveMilestoneTitle] = useState('Pregnancy')

  const setFilteredMilestones = (filter: any, title: any) => {
    setActiveFilter(filter)
    setActiveMilestoneTitle(title)
  }

  useEffect(() => {
    sagaMiddleware.run<any>(setDraftBabyPage, {});
    sagaMiddleware.run<any>(fetchMilestones, (error?: any) => {
      if (error) {
          Modal.error({
            title: "Error",
            content: error,
          });      
      }
    });
  }, []);

  const sendToUpgradeToPlus = () => {
    history.push("/cart/subscription/yearly");
  };

  useEffect(() => {
    const babyPagesCounter = babies.reduce(
      (acc: number, baby: any) => acc + baby.babyPages.length,
      0
    );

    if (babyPagesCounter >= 15 && user.user_level === 0) {
      setBabyPageLimitPlusOpen(true);
    }
  }, [user.user_level]);

  const babyMilestones: MilestonesBaby | undefined = useMemo(() => {
    if (milestones && milestones.milestones.length && babySelected) {
      return milestones.milestones.find((m) => m.id === babySelected.id);
    }
    return undefined;
  }, [milestones, babySelected]);
  const filteredMilestones = babyMilestones ? babyMilestones[activefilter] : [];

  const customId: number = useMemo(() => {
    let index = -1;

    const milestone = milestones.milestones.find((e) => {
      index = e.all_milestones.findIndex(
        (m) => m.title_name === "Custom Page" || m.title === "Custom Page"
      );
      return index !== -1;
    });

    return milestone ? milestone.all_milestones[index].id : 1;
  }, [milestones.milestones]);

  const photoOnlyId: number = useMemo(() => {
    let index = -2;

    const milestone = milestones.milestones.find((e) => {
      index = e.all_milestones.findIndex(
        (m) =>
          m.title_name === "Photo-Only Page" || m.title === "Photo-Only Page"
      );
      return index !== -2;
    });

    return milestone ? milestone.all_milestones[index].id : 1;
  }, [milestones.milestones]);

  // Checking if device is iOS to "force" refresh after loading route
  const isIOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);

  const babyMilestoneButton: string = useMemo(() => {
    if(!!babySelected) {
      let firstName = babySelected?.baby_first_name;
      if(babySelected?.baby_first_name.length >= 25) {

        return `${firstName.slice(0,20)}... MILESTONES`
      } else {
        return `${firstName}'S MILESTONES`
      }
    } else {
      return ""
    }
  }, [babySelected?.baby_first_name])

  return (
    <BaseLayout title="BabyPage - Milestones" pageTitle="Milestones" pageStyle={{backgroundColor:"#f0f0f0"}}>
      <div className="container-fluid" style={{ backgroundColor: "#f0f0f0" }}>
        <div className="container py-3">
          <div className="row align-items-center justify-content-center">
            <div className="col-12 col-sm-11 col-lg-8">
              <div className="row align-items-center justify-content-center">
                {milestones.loading && (
                  <div className="col-12 d-flex justify-content-center">
                    <Spin
                      indicator={
                        <Icon type="loading" style={{ fontSize: 24 }} spin />
                      }
                    />
                  </div>
                )}
                {babySelected && (
                  <>
                    <div className="col-4 col-md-2 p-2 milestone-filter text-center">
                      <Button
                          type="primary"
                          autoFocus
                          onClick={() => setFilteredMilestones("pregnancy_milestones", "Pregnancy")}
                          ghost={activefilter !== "pregnancy_milestones"}
                        >
                          <img
                            src={babyCart}
                            alt=""
                            className="icons-milestones-cart mt-n2 mb-3"
                          />
                          <p className="milestones-buttons-text-bold">
                            Pregnancy
                          </p>
                        </Button>
                    </div>
                    <div className="col-4 col-md-2 p-2 milestone-filter text-center">
                    <Button
                        type="primary"   
                        onClick={() => setFilteredMilestones("baby_milestones", "Age")}
                        ghost={activefilter !== "baby_milestones"}
                      >
                        <img
                          src={babyShirt}
                          alt=""
                          className="icons-milestones-shirt mt-n2 mb-3"
                        />
                        <p className="milestones-buttons-text-bold">Age</p>
                      </Button>
                    </div>
                    <div className="col-4 col-md-2 p-2 milestone-filter text-center">
                      <Button
                        type="primary"
                        onClick={() => setFilteredMilestones("first_event_milestones", "1st Events")}
                        ghost={activefilter !== "first_event_milestones"}
                      >
                        <img
                          src={babyFoot}
                          alt=""
                          className="icons-milestones-foot mt-n2 mb-3"
                        />
                        <p className="milestones-buttons-text-bold">
                          1st Events
                        </p>
                      </Button>
                    </div>
                    <div className="col-4 col-md-2 p-2 milestone-filter text-center">
                      <Button
                        type="primary"
                        onClick={() => setFilteredMilestones("holiday_milestones", "Holidays")}
                        ghost={activefilter !== "holiday_milestones"}
                      >
                        <img
                          src={babySock}
                          alt=""
                          className="icons-milestones-sock mt-n2 mb-3"
                        />
                        <p className="milestones-buttons-text-bold">Holidays</p>
                      </Button>
                    </div>
                    <div className="col-4 col-md-2 p-2 milestone-filter text-center">
                      <Button
                        type="primary"
                        onClick={() => setFilteredMilestones("incomplete_milestones", "Incomplete")}
                        ghost={activefilter !== "incomplete_milestones"}
                      >
                        <img
                          src={babyIncomplete}
                          alt=""
                          className="icons-milestones-incomplete mt-n2 mb-3"
                        />
                        <p className="milestones-buttons-text-bold">
                          Incomplete
                        </p>
                      </Button>
                    </div>
                    <div className="col-4 col-md-2  p-2 milestone-filter text-center">
                      <Button
                        type="primary"
                        onClick={() => setFilteredMilestones("all_milestones", "View All")}
                        ghost={activefilter !== "all_milestones"}
                      >
                        <img
                          src={babyFace}
                          alt=""
                          className="icons-milestones-face mt-n2 mb-3"
                        />
                        <p className="milestones-buttons-text-bold">View All</p>
                      </Button>
                    </div>
                  </>
                )}
              </div>
              <div className="row align-items-center justify-content-center mt-3 mb-3">
                <div className="col-6 col-md-3 milestone-filter text-center">             
                    <Link to={`/babypages/save?milestoneId=${customId}`}>
                      <Button
                        type="primary"
                        ghost
                        className="milestones-buttons-radius force-width-button"
                      >
                        <p className="milestones-buttons-text-bold">
                          Custom Pages
                        </p>
                      </Button>
                    </Link>
                </div>
                {!!photoOnlyId && (
                  <div className="col-6 col-md-3 milestone-filter text-center">
                    <Button
                      type="primary"
                      ghost
                      className="milestones-buttons-radius force-width-button"
                      onClick={() => {
                        if (localStorage.onlyPhotoBPCreated) {
                          history.push(
                            `/babypages/save?milestoneId=${photoOnlyId}`
                          );
                        } else {
                          Modal.info({
                            title: "Hi there!",
                            content: `Photo Only milestones allow you to create babypages with photos
                          on both sides of the page. No auto-generated content is included, but you 
                          can add a label/title.`,
                            okText: "Got It",
                            onOk: () =>
                              history.push(
                                `/babypages/save?milestoneId=${photoOnlyId}`
                              ),
                            maskClosable: true,
                          });
                        }
                      }}
                    >
                      <p className="milestones-buttons-text-bold">
                        Photo Only Pages
                      </p>
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid" style={{ backgroundColor: "#f0f0f0" }}>
        <div className="row align-items-center justify-content-center">
          <div className="col-12">
            <div className="row mb-0">
              <MilestonesList milestones={filteredMilestones} milestoneTitle={activeMilestoneTitle} />
            </div>
          </div>
        </div>
      </div>
      <ModalPlus
        visible={babyPageLimitPlusOpen}
        onClose={() => history.goBack()}
        onSaveBeforeUpgradeToPlus={sendToUpgradeToPlus}
        customText="You reached the limit of BabyPages as a free user. Upgrade to PLUS to create more."
      />
    </BaseLayout>
  );
};

const mapStateToProps = (state: AppState) => ({
  babySelected: state.baby.babySelected,
  babies: state.baby.babies,
  user: state.user,
  milestones: state.milestones,
});



export default connect(mapStateToProps)(MilestonesPage);
